'use strict';

// const urlUtil = require('./urlUtil');
const recaptcha = require('core/components/recaptcha');

const isMargiela = document.querySelector('body').getAttribute('data-sitebrand') === "Margiela";
const isMarni = document.querySelector('body').getAttribute('data-sitebrand') === "Marni";
const isJilSander = document.body.dataset.sitebrand === "JilSander";

let isVisible = false;

const showEtaExtraInfoMessage = (ev) => {
  const messageBox = ev.target.closest('.item-shipping-price').querySelector('.eta-extra-info-message');
  const messageIconToggler = ev.target.closest('.eta-extra-info-icon');
  if(isVisible) {
    messageBox.classList.remove('visible');
    messageIconToggler.classList.remove('active');
  } else {
    messageBox.classList.add('visible');
    messageIconToggler.classList.add('active');
  }
}

const addTooltipClickBehaviour = () => {
  const extraInfoIcons = document.querySelectorAll('.eta-extra-info-icon');
  if(extraInfoIcons) {
    extraInfoIcons.forEach(i => i.addEventListener('click', function(e) {
      showEtaExtraInfoMessage(e);
      isVisible = !isVisible;
    }));
  }
}


/**
 * Function used to have the correct behaviour on duties/taxes tooltip hover
 */
const addTooltipHoverBehaviour = () => {
  const dutiesTooltipBox = document.querySelector('.tooltip-global-container .duties-tooltip-box');
  const taxesTooltipBox = document.querySelector('.tooltip-global-container .taxes-tooltip-box');
  $('.tooltip-global-container .duties-tooltip-toggler').on('mouseover', () => dutiesTooltipBox.classList.add('visible'));
  $('.tooltip-global-container .duties-tooltip-toggler').on('mouseleave', () => dutiesTooltipBox.classList.remove('visible'));
  $('.tooltip-global-container .taxes-tooltip-toggler').on('mouseover', () => taxesTooltipBox.classList.add('visible'));
  $('.tooltip-global-container .taxes-tooltip-toggler').on('mouseleave', () => taxesTooltipBox.classList.remove('visible'));
}

const submitContactForm = (event) => {
  event.preventDefault();
  $.spinner().start();
  let submitForm = function () {
    const $form = $('form#contact-us-form');
    let inputs = $('form#contact-us-form input, form#contact-us-form select, form#contact-us-form textarea');
    let hiddenForm = document.createElement('form');
    hiddenForm.method = $form.attr('method');
    var isValidForm = true;
    
    inputs.each(function (i) {
      let originalInput = $(this);
      let newInput = document.createElement('input');
      newInput.name = originalInput.attr('name');
      newInput.value = originalInput.val();
      newInput.setAttribute('type', 'hidden');
      hiddenForm.appendChild(newInput);

      if(originalInput.prop('required') && originalInput.val() == ''){
        isValidForm = false;
        return false;
      }

      // IBT-3439
      if(originalInput.hasClass('error')){
        isValidForm = false;
        return false;
      }
    });

    if (!isValidForm) {
      $.spinner().stop();
      return;
    }

    document.body.appendChild(hiddenForm);

    $.ajax({
      url: $form.attr('action'),
      type: "post",
      dataType: "json",
      data: $form.serialize(),
      success: function(data) {
        if (data.success && data.contactUsUrl) {
          hiddenForm.action = data.contactUsUrl;
          hiddenForm.submit();
        }
      }
    });
  };

  if ($('form#contact-us-form').find('.g-recaptcha').length > 0) {
    let siteKey = $('#recaptchaSitekey').length > 0 ? $('#recaptchaSitekey').val() : null;
      if (siteKey) {
        recaptcha.loadReCaptcha(siteKey).then(function() {
          grecaptcha.ready(function() {
            grecaptcha.execute(siteKey, {action:'submit'}).then(function(token) {
              $('#g-recaptcha-response').val(token);
              $('#gReCaptchaWidget').val(token);
              submitForm();
            });
          });
        });
      }
  } else {
    submitForm();
  }
  return false;
}

module.exports = {
  onFormInit: function() {
    const isMobile = window.innerWidth <= 1024;
    if (!isMobile) {
      $('#contact-us-form .fsb-option').on('click', function(e) {
        var value = e.currentTarget.textContent;

        if (value) {
          $('#subject').val(value);
          $('#subject').parent().find('#bouncer-error_subject').remove();
        }
      });
    }
  },
  orderFormSubmit: function () {
    $('body').on('submit', '.help-search-order', function (event) {
      event.preventDefault();
      const $form = $(event.target);
      
      $.spinner().start();
      
      $.post({
        url: $form.attr('action'),
        dataType: 'json',
        data: $form.serialize(),
        success: function (data) {
          if (data.success) {
            $('body').find('.check-order-before-login').remove();
            if(isMarni) {
              $('body').find('.help-content-box').first().replaceWith(data.detailsHtml);
              $('body').find('.help-content-box').remove();
            } else {
            $('body').find('.help-content-box').replaceWith(data.detailsHtml);
            }
            $('body').trigger('help:orderDetailsOpened', data);
            if(isMargiela) {
              addTooltipClickBehaviour();
              addTooltipHoverBehaviour();
            }
            if(isJilSander) {
              document.querySelector('.order-search-return') && document.querySelector('.order-search-return').classList.add('search-result-wrapper');
            }
          } else {
            $form.find('.alert').remove();
            
            const alertEl = document.createElement('div');
            alertEl.classList.add('alert');
            alertEl.classList.add('mm-form-message');
            alertEl.textContent = data.errorMessage;
            $form.append(alertEl);
          }
          $.spinner().stop();
        },
        error: function () {
          $.spinner().stop();
        },
      });
    });
  },
  contactUsFormSubmit: function () {
    if(isJilSander) {
      $('#contact-us-form').on('bouncerFormValid', function (e) {
        submitContactForm(e);
      });
    } else {
      $('body').on('submit', '#contact-us-form', function (event) {
        submitContactForm(event);
      });
    }
  },
  // positionNotification: function () {
  //   $(window).on('scroll', function () {
  //     if ($(window).scrollTop() === 0) {
  //       $('.success-notification').css('position', 'relative');
  //     }
  //   });
  // },
  // autoStatusSubmit: function () {
  //   const orderNumber = urlUtil.getParameterByName('orderNumber');
  //   const orderEmail = urlUtil.getParameterByName('orderEmail');

  //   if (orderNumber && orderEmail) {
  //     const $form = $('#help-order-status-form');
  //     $form.find('#orderNumber').val(orderNumber);
  //     $form.find('#orderEmail').val(orderEmail);
  //     $form.trigger('submit');
  //   }
  // },
};
